<template>
	<div class="eia-footer-links-container">
		<div class="eia-footer-links">
			<div class="eia-page-boundary-container">
				<div class="eia-footer-links__links">
					<eia-link :to="{path:'cookie-policy'}">Cookies</eia-link>
					<eia-link :to="{path:'faq'}">Help</eia-link>
					<eia-link :to="{path:'privacy-policy'}">Privacy</eia-link>
					<eia-link :to="{path:'terms-of-use'}">Terms and Conditions</eia-link>
				</div>

				<div class="eia-footer-links__images">
				</div>
			</div>
			<eia-version-info></eia-version-info>
		</div>
		<div class="copyright-notice">&copy; Quod Limited {{ (new Date().getFullYear()) }}. All rights reserved.</div>
	</div>
</template>

<script>
export default {
	name: 'eia-footer-links',
};
</script>

<style lang="scss" scoped>

.copyright-notice{
	text-align: center;
	padding: 1rem 0;
	font-size: 0.75rem;
}

.eia-footer-links-container {
	background: $color-grey-dark;
}

.eia-footer-links {
	padding: 24px 0;
	border-top: 1px solid $color-grey-medium;
	display: block;
	flex-grow: 1;
	width: 100%;
	align-items: flex-start;
	justify-content: space-between;

	&__links {
		column-count: 2;
		max-width: 416px;
		margin: 0 auto;

		> * {
			display: block;
			line-height: 1.5;
			color: $color-white;
		}
	}

	&__images {
		text-align: center;
		margin-top: 16px;

		> * {
			margin: 4px;
		}
	}

	@media screen and (min-width: $screen-l) {
		display: flex;
		align-items: flex-start;

		&__links {
			margin: 0;
		}

		&__images {
			margin-top: 0;
		}
	}
}
</style>
